<template>
  <div class="cardbody maxheight">
    <div class="row justify-content-center">
      <div class="col-8 mt-4">
        <div class="row lead">
          {{ data.title }}
        </div>
        <div class="row my-5">
          <p v-for="(item,index) in data.responses" :key="index">
            {{item}}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer border border-rounded">
    <div class="row justify-content-center">
      <div @click="$emit('advance')" class="btn btn-small nsc-cta blue mx-2 my-2">
        See your results!
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Conclusion",
  props: ["data"],
  emits: ["advance"],
};
</script>